import styled from '@emotion/styled'
import { colors } from 'ic-snacks'

const BAR_WIDTH = 2

const ShiftRowCurrentHourBar = styled.div<{ percentageFromLeft: number }>(
  ({ percentageFromLeft }) => ({
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: `calc(${percentageFromLeft}% - ${BAR_WIDTH / 2}px)`,
    width: `${BAR_WIDTH}px`,
    backgroundColor: colors.RED_600,
    zIndex: 1,
  })
)

export default ShiftRowCurrentHourBar
